<form class="grid col2 container-account-pago-movil" [formGroup]="accountPagoMovilForm">
    <mat-form-field appearance="outline">
        <mat-label>{{ getCountryLabel() }}</mat-label>
        <mat-select formControlName="codeBankPagoMovil">
            <mat-option *ngFor="let item of infoBank" [value]="item.codeBank || item.nameBank">
                <ng-container *ngIf="systemId !== 'banco_bol'">
                    {{ item.codeBank }} - {{ item.nameBank }}
                </ng-container>
                <ng-container *ngIf="systemId === 'banco_bol'">
                    {{ item.nameBank }}
                </ng-container>
            </mat-option>
        </mat-select>
        <mat-error>{{ getIncorrectSelect() }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
        <mat-label>{{ getLabel() }}</mat-label>
        <input matInput type="text" formControlName="phonePagoMovil" [placeholder]="getPlaceholder()">
        <mat-error>{{ getIncorrectLabel() }}</mat-error>
    </mat-form-field>
</form>
